// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__u0R7v","contentWrapper":"styles_content-wrapper__e_YAf","content":"styles_content__Zl7Q3"};